// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AlamoSeriesRouteImport } from './routes/alamo-series'
import { Route as AransasPassRouteImport } from './routes/aransas-pass'
import { Route as ArchitectsRouteImport } from './routes/architects'
import { Route as AustinRouteImport } from './routes/austin'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AwningsRouteImport } from './routes/awnings'
import { Route as BacklitAwningsRouteImport } from './routes/backlit-awnings'
import { Route as BanderaRouteImport } from './routes/bandera'
import { Route as BastropRouteImport } from './routes/bastrop'
import { Route as BeevilleRouteImport } from './routes/beeville'
import { Route as BluebonnetSeriesRouteImport } from './routes/bluebonnet-series'
import { Route as BoatCoversRouteImport } from './routes/boat-covers'
import { Route as BoerneRouteImport } from './routes/boerne'
import { Route as BrownsvilleRouteImport } from './routes/brownsville'
import { Route as BudaRouteImport } from './routes/buda'
import { Route as BuiltInTexasRouteImport } from './routes/built-in-texas'
import { Route as BulverdeRouteImport } from './routes/bulverde'
import { Route as CanyonLakeRouteImport } from './routes/canyon-lake'
import { Route as CarWashShadeSailsRouteImport } from './routes/car-wash-shade-sails'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as CastrovilleRouteImport } from './routes/castroville'
import { Route as CedarParkRouteImport } from './routes/cedar-park'
import { Route as CentralTexasRouteImport } from './routes/central-texas'
import { Route as ChurchShadeStructuresRouteImport } from './routes/church-shade-structures'
import { Route as CiboloRouteImport } from './routes/cibolo'
import { Route as ComfortRouteImport } from './routes/comfort'
import { Route as CommercialAwningsRouteImport } from './routes/commercial-awnings'
import { Route as CommercialEventTentsRouteImport } from './routes/commercial-event-tents'
import { Route as ConroeRouteImport } from './routes/conroe'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConverseRouteImport } from './routes/converse'
import { Route as CoolerGunGearCoversRouteImport } from './routes/cooler-gun-gear-covers'
import { Route as CorpusChristiRouteImport } from './routes/corpus-christi'
import { Route as CoveredParkingRouteImport } from './routes/covered-parking'
import { Route as CoversChar38TopsRouteImport } from './routes/covers-[&]-tops'
import { Route as CoversTopsRouteImport } from './routes/covers-tops'
import { Route as CueroRouteImport } from './routes/cuero'
import { Route as CurtainsRouteImport } from './routes/curtains'
import { Route as CustomAwningsRouteImport } from './routes/custom-awnings'
import { Route as CustomFabricationRouteImport } from './routes/custom-fabrication'
import { Route as DeerBlindCoversRouteImport } from './routes/deer-blind-covers'
import { Route as DeerBlindsAndHuntingRouteImport } from './routes/deer-blinds-and-hunting'
import { Route as DelRioRouteImport } from './routes/del-rio'
import { Route as DogBoxesRouteImport } from './routes/dog-boxes'
import { Route as DrippingSpringsRouteImport } from './routes/dripping-springs'
import { Route as EaglePassRouteImport } from './routes/eagle-pass'
import { Route as EdinburgRouteImport } from './routes/edinburg'
import { Route as EstimateQuotesRouteImport } from './routes/estimate-quotes'
import { Route as ExteriorVerticalShadesRouteImport } from './routes/exterior-vertical-shades'
import { Route as FabricAwningsRouteImport } from './routes/fabric-awnings'
import { Route as FabricsRouteImport } from './routes/fabrics'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as FarmingRanchingSeriesRouteImport } from './routes/farming-ranching-series'
import { Route as FindYourShadeRouteImport } from './routes/find-your-shade'
import { Route as FloresvilleRouteImport } from './routes/floresville'
import { Route as FredericksburgRouteImport } from './routes/fredericksburg'
import { Route as GalvestonRouteImport } from './routes/galveston'
import { Route as GazeboPrivacyPanelsRouteImport } from './routes/gazebo-privacy-panels'
import { Route as GeorgetownRouteImport } from './routes/georgetown'
import { Route as GonzalesRouteImport } from './routes/gonzales'
import { Route as GulfCoastRouteImport } from './routes/gulf-coast'
import { Route as HarlingenRouteImport } from './routes/harlingen'
import { Route as HelotesRouteImport } from './routes/helotes'
import { Route as HillCountryRouteImport } from './routes/hill-country'
import { Route as HillCountrySeriesRouteImport } from './routes/hill-country-series'
import { Route as HogTrapsAndCagesRouteImport } from './routes/hog-traps-and-cages'
import { Route as HondoRouteImport } from './routes/hondo'
import { Route as HoustonRouteImport } from './routes/houston'
import { Route as HuntingFishingCoversRouteImport } from './routes/hunting-fishing-covers'
import { Route as KatyRouteImport } from './routes/katy'
import { Route as KerrvilleRouteImport } from './routes/kerrville'
import { Route as KingsvilleRouteImport } from './routes/kingsville'
import { Route as KyleRouteImport } from './routes/kyle'
import { Route as LaredoRouteImport } from './routes/laredo'
import { Route as LeagueCityRouteImport } from './routes/league-city'
import { Route as LiveOakRouteImport } from './routes/live-oak'
import { Route as LocalFaqsRouteImport } from './routes/local-faqs'
import { Route as LockhartRouteImport } from './routes/lockhart'
import { Route as LoneStarEliteRouteImport } from './routes/lone-star-elite'
import { Route as LonghornSeriesRouteImport } from './routes/longhorn-series'
import { Route as LouveredPergolasRouteImport } from './routes/louvered-pergolas'
import { Route as LulingRouteImport } from './routes/luling'
import { Route as McallenRouteImport } from './routes/mcallen'
import { Route as MetalAwningsRouteImport } from './routes/metal-awnings'
import { Route as NewBraunfelsRouteImport } from './routes/new-braunfels'
import { Route as OutdoorCoolingMistingRouteImport } from './routes/outdoor-cooling-misting'
import { Route as OutdoorHvacRouteImport } from './routes/outdoor-hvac'
import { Route as OutdoorLightingRouteImport } from './routes/outdoor-lighting'
import { Route as OutdoorRecreationSeriesRouteImport } from './routes/outdoor-recreation-series'
import { Route as PatioCanopyRouteImport } from './routes/patio-canopy'
import { Route as PatioCoversRouteImport } from './routes/patio-covers'
import { Route as PearlandRouteImport } from './routes/pearland'
import { Route as PergolaCoversRouteImport } from './routes/pergola-covers'
import { Route as PflugervilleRouteImport } from './routes/pflugerville'
import { Route as PlaygroundShadeRouteImport } from './routes/playground-shade'
import { Route as PleasantonRouteImport } from './routes/pleasanton'
import { Route as PoolSpaRouteImport } from './routes/pool-spa'
import { Route as PortAransasRouteImport } from './routes/port-aransas'
import { Route as PortOconnorRouteImport } from './routes/port-oconnor'
import { Route as PortlandRouteImport } from './routes/portland'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as RangerCareRouteImport } from './routes/ranger-care'
import { Route as RangerSeriesRouteImport } from './routes/ranger-series'
import { Route as RecoverAwningsRouteImport } from './routes/recover-awnings'
import { Route as RepublicSeriesRouteImport } from './routes/republic-series'
import { Route as RequestAQuoteRouteImport } from './routes/request-a-quote'
import { Route as ResidentialAwningsRouteImport } from './routes/residential-awnings'
import { Route as RestaurantAwningsRouteImport } from './routes/restaurant-awnings'
import { Route as RetractableAwningsRouteImport } from './routes/retractable-awnings'
import { Route as RevivalSeriesRouteImport } from './routes/revival-series'
import { Route as RioGrandeSeriesRouteImport } from './routes/rio-grande-series'
import { Route as RockportRouteImport } from './routes/rockport'
import { Route as RoundRockRouteImport } from './routes/round-rock'
import { Route as RvCoversRouteImport } from './routes/rv-covers'
import { Route as SafariGlampingTentsRouteImport } from './routes/safari-glamping-tents'
import { Route as SailShadesRouteImport } from './routes/sail-shades'
import { Route as SanAntonioRouteImport } from './routes/san-antonio'
import { Route as SanMarcosRouteImport } from './routes/san-marcos'
import { Route as SchertzRouteImport } from './routes/schertz'
import { Route as SchoolShadeStructuresRouteImport } from './routes/school-shade-structures'
import { Route as SchoolsAthleticsRouteImport } from './routes/schools-athletics'
import { Route as SeguinRouteImport } from './routes/seguin'
import { Route as SeriesRouteImport } from './routes/series'
import { Route as ServiceAreasRouteImport } from './routes/service-areas'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as SolairVsRouteImport } from './routes/solair-vs'
import { Route as SouthPadreIslandRouteImport } from './routes/south-padre-island'
import { Route as SpringBranchRouteImport } from './routes/spring-branch'
import { Route as StockTrailerCoversRouteImport } from './routes/stock-trailer-covers'
import { Route as SugarLandRouteImport } from './routes/sugar-land'
import { Route as TheWoodlandsRouteImport } from './routes/the-woodlands'
import { Route as TrailerCoversRouteImport } from './routes/trailer-covers'
import { Route as TrailerWiringRouteImport } from './routes/trailer-wiring'
import { Route as UniversalCityRouteImport } from './routes/universal-city'
import { Route as UtvAtvCoversRouteImport } from './routes/utv-atv-covers'
import { Route as UvaldeRouteImport } from './routes/uvalde'
import { Route as VerticalShadesLpRouteImport } from './routes/vertical-shades-lp'
import { Route as VictoriaRouteImport } from './routes/victoria'
import { Route as ViewOurWorkRouteImport } from './routes/view-our-work'
import { Route as WagonCoversRouteImport } from './routes/wagon-covers'
import { Route as WhyTexasMadeShadeRouteImport } from './routes/why-texas-made-shade'
import { Route as WimberleyRouteImport } from './routes/wimberley'
import { Route as AdminAlertsRouteImport } from './routes/admin.alerts'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminBlogRouteImport } from './routes/admin.blog'
import { Route as AdminSearchesRouteImport } from './routes/admin.searches'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as SeriesSlugRouteImport } from './routes/series.$slug'
import { Route as ShopOrderCompleteRouteImport } from './routes/shop.order-complete'
import { Route as VideosDropCurtainsRouteImport } from './routes/videos.drop-curtains'
import { Route as VideosSunbrellaFabricRouteImport } from './routes/videos.sunbrella-fabric'
import { Route as AluminumPatioCoversInAustinRouteImport } from './routes/aluminum-patio-covers.in.austin'
import { Route as AluminumPatioCoversInSanAntonioRouteImport } from './routes/aluminum-patio-covers.in.san-antonio'
import { Route as AwningsInCityRouteImport } from './routes/awnings.in.$city'
import { Route as BlogTopicTagRouteImport } from './routes/blog.topic.$tag'
import { Route as BoatCoversInCityRouteImport } from './routes/boat-covers.in.$city'
import { Route as CaseStudiesInCityRouteImport } from './routes/case-studies.in.$city'
import { Route as InsulatedPatioCoversInAustinRouteImport } from './routes/insulated-patio-covers.in.austin'
import { Route as InsulatedPatioCoversInSanAntonioRouteImport } from './routes/insulated-patio-covers.in.san-antonio'
import { Route as LouveredPatioCoversInAustinRouteImport } from './routes/louvered-patio-covers.in.austin'
import { Route as LouveredPatioCoversInSanAntonioRouteImport } from './routes/louvered-patio-covers.in.san-antonio'
import { Route as MotorizedDropScreensInCityRouteImport } from './routes/motorized-drop-screens.in.$city'
import { Route as PatioCoversInAustinRouteImport } from './routes/patio-covers.in.austin'
import { Route as PatioCoversInSanAntonioRouteImport } from './routes/patio-covers.in.san-antonio'
import { Route as PatioEnclosuresInAustinRouteImport } from './routes/patio-enclosures.in.austin'
import { Route as PatioEnclosuresInSanAntonioRouteImport } from './routes/patio-enclosures.in.san-antonio'
import { Route as PergolaCoversInCityRouteImport } from './routes/pergola-covers.in.$city'
import { Route as RecoverAwningsInCityRouteImport } from './routes/recover-awnings.in.$city'
import { Route as ShopBoatingSlugRouteImport } from './routes/shop.boating.$slug'
import { Route as ShopCleanersSlugRouteImport } from './routes/shop.cleaners.$slug'
import { Route as ShopGluesSlugRouteImport } from './routes/shop.glues.$slug'
import { Route as ShopHardwareSlugRouteImport } from './routes/shop.hardware.$slug'
import { Route as ShopThreadsSlugRouteImport } from './routes/shop.threads.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AlamoSeriesRoute = AlamoSeriesRouteImport.update({
            id: '/alamo-series',path: '/alamo-series',getParentRoute: () => rootRouteImport
          })
const AransasPassRoute = AransasPassRouteImport.update({
            id: '/aransas-pass',path: '/aransas-pass',getParentRoute: () => rootRouteImport
          })
const ArchitectsRoute = ArchitectsRouteImport.update({
            id: '/architects',path: '/architects',getParentRoute: () => rootRouteImport
          })
const AustinRoute = AustinRouteImport.update({
            id: '/austin',path: '/austin',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AwningsRoute = AwningsRouteImport.update({
            id: '/awnings',path: '/awnings',getParentRoute: () => rootRouteImport
          })
const BacklitAwningsRoute = BacklitAwningsRouteImport.update({
            id: '/backlit-awnings',path: '/backlit-awnings',getParentRoute: () => rootRouteImport
          })
const BanderaRoute = BanderaRouteImport.update({
            id: '/bandera',path: '/bandera',getParentRoute: () => rootRouteImport
          })
const BastropRoute = BastropRouteImport.update({
            id: '/bastrop',path: '/bastrop',getParentRoute: () => rootRouteImport
          })
const BeevilleRoute = BeevilleRouteImport.update({
            id: '/beeville',path: '/beeville',getParentRoute: () => rootRouteImport
          })
const BluebonnetSeriesRoute = BluebonnetSeriesRouteImport.update({
            id: '/bluebonnet-series',path: '/bluebonnet-series',getParentRoute: () => rootRouteImport
          })
const BoatCoversRoute = BoatCoversRouteImport.update({
            id: '/boat-covers',path: '/boat-covers',getParentRoute: () => rootRouteImport
          })
const BoerneRoute = BoerneRouteImport.update({
            id: '/boerne',path: '/boerne',getParentRoute: () => rootRouteImport
          })
const BrownsvilleRoute = BrownsvilleRouteImport.update({
            id: '/brownsville',path: '/brownsville',getParentRoute: () => rootRouteImport
          })
const BudaRoute = BudaRouteImport.update({
            id: '/buda',path: '/buda',getParentRoute: () => rootRouteImport
          })
const BuiltInTexasRoute = BuiltInTexasRouteImport.update({
            id: '/built-in-texas',path: '/built-in-texas',getParentRoute: () => rootRouteImport
          })
const BulverdeRoute = BulverdeRouteImport.update({
            id: '/bulverde',path: '/bulverde',getParentRoute: () => rootRouteImport
          })
const CanyonLakeRoute = CanyonLakeRouteImport.update({
            id: '/canyon-lake',path: '/canyon-lake',getParentRoute: () => rootRouteImport
          })
const CarWashShadeSailsRoute = CarWashShadeSailsRouteImport.update({
            id: '/car-wash-shade-sails',path: '/car-wash-shade-sails',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const CastrovilleRoute = CastrovilleRouteImport.update({
            id: '/castroville',path: '/castroville',getParentRoute: () => rootRouteImport
          })
const CedarParkRoute = CedarParkRouteImport.update({
            id: '/cedar-park',path: '/cedar-park',getParentRoute: () => rootRouteImport
          })
const CentralTexasRoute = CentralTexasRouteImport.update({
            id: '/central-texas',path: '/central-texas',getParentRoute: () => rootRouteImport
          })
const ChurchShadeStructuresRoute = ChurchShadeStructuresRouteImport.update({
            id: '/church-shade-structures',path: '/church-shade-structures',getParentRoute: () => rootRouteImport
          })
const CiboloRoute = CiboloRouteImport.update({
            id: '/cibolo',path: '/cibolo',getParentRoute: () => rootRouteImport
          })
const ComfortRoute = ComfortRouteImport.update({
            id: '/comfort',path: '/comfort',getParentRoute: () => rootRouteImport
          })
const CommercialAwningsRoute = CommercialAwningsRouteImport.update({
            id: '/commercial-awnings',path: '/commercial-awnings',getParentRoute: () => rootRouteImport
          })
const CommercialEventTentsRoute = CommercialEventTentsRouteImport.update({
            id: '/commercial-event-tents',path: '/commercial-event-tents',getParentRoute: () => rootRouteImport
          })
const ConroeRoute = ConroeRouteImport.update({
            id: '/conroe',path: '/conroe',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConverseRoute = ConverseRouteImport.update({
            id: '/converse',path: '/converse',getParentRoute: () => rootRouteImport
          })
const CoolerGunGearCoversRoute = CoolerGunGearCoversRouteImport.update({
            id: '/cooler-gun-gear-covers',path: '/cooler-gun-gear-covers',getParentRoute: () => rootRouteImport
          })
const CorpusChristiRoute = CorpusChristiRouteImport.update({
            id: '/corpus-christi',path: '/corpus-christi',getParentRoute: () => rootRouteImport
          })
const CoveredParkingRoute = CoveredParkingRouteImport.update({
            id: '/covered-parking',path: '/covered-parking',getParentRoute: () => rootRouteImport
          })
const CoversChar38TopsRoute = CoversChar38TopsRouteImport.update({
            id: '/covers-&-tops',path: '/covers-&-tops',getParentRoute: () => rootRouteImport
          })
const CoversTopsRoute = CoversTopsRouteImport.update({
            id: '/covers-tops',path: '/covers-tops',getParentRoute: () => rootRouteImport
          })
const CueroRoute = CueroRouteImport.update({
            id: '/cuero',path: '/cuero',getParentRoute: () => rootRouteImport
          })
const CurtainsRoute = CurtainsRouteImport.update({
            id: '/curtains',path: '/curtains',getParentRoute: () => rootRouteImport
          })
const CustomAwningsRoute = CustomAwningsRouteImport.update({
            id: '/custom-awnings',path: '/custom-awnings',getParentRoute: () => rootRouteImport
          })
const CustomFabricationRoute = CustomFabricationRouteImport.update({
            id: '/custom-fabrication',path: '/custom-fabrication',getParentRoute: () => rootRouteImport
          })
const DeerBlindCoversRoute = DeerBlindCoversRouteImport.update({
            id: '/deer-blind-covers',path: '/deer-blind-covers',getParentRoute: () => rootRouteImport
          })
const DeerBlindsAndHuntingRoute = DeerBlindsAndHuntingRouteImport.update({
            id: '/deer-blinds-and-hunting',path: '/deer-blinds-and-hunting',getParentRoute: () => rootRouteImport
          })
const DelRioRoute = DelRioRouteImport.update({
            id: '/del-rio',path: '/del-rio',getParentRoute: () => rootRouteImport
          })
const DogBoxesRoute = DogBoxesRouteImport.update({
            id: '/dog-boxes',path: '/dog-boxes',getParentRoute: () => rootRouteImport
          })
const DrippingSpringsRoute = DrippingSpringsRouteImport.update({
            id: '/dripping-springs',path: '/dripping-springs',getParentRoute: () => rootRouteImport
          })
const EaglePassRoute = EaglePassRouteImport.update({
            id: '/eagle-pass',path: '/eagle-pass',getParentRoute: () => rootRouteImport
          })
const EdinburgRoute = EdinburgRouteImport.update({
            id: '/edinburg',path: '/edinburg',getParentRoute: () => rootRouteImport
          })
const EstimateQuotesRoute = EstimateQuotesRouteImport.update({
            id: '/estimate-quotes',path: '/estimate-quotes',getParentRoute: () => rootRouteImport
          })
const ExteriorVerticalShadesRoute = ExteriorVerticalShadesRouteImport.update({
            id: '/exterior-vertical-shades',path: '/exterior-vertical-shades',getParentRoute: () => rootRouteImport
          })
const FabricAwningsRoute = FabricAwningsRouteImport.update({
            id: '/fabric-awnings',path: '/fabric-awnings',getParentRoute: () => rootRouteImport
          })
const FabricsRoute = FabricsRouteImport.update({
            id: '/fabrics',path: '/fabrics',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const FarmingRanchingSeriesRoute = FarmingRanchingSeriesRouteImport.update({
            id: '/farming-ranching-series',path: '/farming-ranching-series',getParentRoute: () => rootRouteImport
          })
const FindYourShadeRoute = FindYourShadeRouteImport.update({
            id: '/find-your-shade',path: '/find-your-shade',getParentRoute: () => rootRouteImport
          })
const FloresvilleRoute = FloresvilleRouteImport.update({
            id: '/floresville',path: '/floresville',getParentRoute: () => rootRouteImport
          })
const FredericksburgRoute = FredericksburgRouteImport.update({
            id: '/fredericksburg',path: '/fredericksburg',getParentRoute: () => rootRouteImport
          })
const GalvestonRoute = GalvestonRouteImport.update({
            id: '/galveston',path: '/galveston',getParentRoute: () => rootRouteImport
          })
const GazeboPrivacyPanelsRoute = GazeboPrivacyPanelsRouteImport.update({
            id: '/gazebo-privacy-panels',path: '/gazebo-privacy-panels',getParentRoute: () => rootRouteImport
          })
const GeorgetownRoute = GeorgetownRouteImport.update({
            id: '/georgetown',path: '/georgetown',getParentRoute: () => rootRouteImport
          })
const GonzalesRoute = GonzalesRouteImport.update({
            id: '/gonzales',path: '/gonzales',getParentRoute: () => rootRouteImport
          })
const GulfCoastRoute = GulfCoastRouteImport.update({
            id: '/gulf-coast',path: '/gulf-coast',getParentRoute: () => rootRouteImport
          })
const HarlingenRoute = HarlingenRouteImport.update({
            id: '/harlingen',path: '/harlingen',getParentRoute: () => rootRouteImport
          })
const HelotesRoute = HelotesRouteImport.update({
            id: '/helotes',path: '/helotes',getParentRoute: () => rootRouteImport
          })
const HillCountryRoute = HillCountryRouteImport.update({
            id: '/hill-country',path: '/hill-country',getParentRoute: () => rootRouteImport
          })
const HillCountrySeriesRoute = HillCountrySeriesRouteImport.update({
            id: '/hill-country-series',path: '/hill-country-series',getParentRoute: () => rootRouteImport
          })
const HogTrapsAndCagesRoute = HogTrapsAndCagesRouteImport.update({
            id: '/hog-traps-and-cages',path: '/hog-traps-and-cages',getParentRoute: () => rootRouteImport
          })
const HondoRoute = HondoRouteImport.update({
            id: '/hondo',path: '/hondo',getParentRoute: () => rootRouteImport
          })
const HoustonRoute = HoustonRouteImport.update({
            id: '/houston',path: '/houston',getParentRoute: () => rootRouteImport
          })
const HuntingFishingCoversRoute = HuntingFishingCoversRouteImport.update({
            id: '/hunting-fishing-covers',path: '/hunting-fishing-covers',getParentRoute: () => rootRouteImport
          })
const KatyRoute = KatyRouteImport.update({
            id: '/katy',path: '/katy',getParentRoute: () => rootRouteImport
          })
const KerrvilleRoute = KerrvilleRouteImport.update({
            id: '/kerrville',path: '/kerrville',getParentRoute: () => rootRouteImport
          })
const KingsvilleRoute = KingsvilleRouteImport.update({
            id: '/kingsville',path: '/kingsville',getParentRoute: () => rootRouteImport
          })
const KyleRoute = KyleRouteImport.update({
            id: '/kyle',path: '/kyle',getParentRoute: () => rootRouteImport
          })
const LaredoRoute = LaredoRouteImport.update({
            id: '/laredo',path: '/laredo',getParentRoute: () => rootRouteImport
          })
const LeagueCityRoute = LeagueCityRouteImport.update({
            id: '/league-city',path: '/league-city',getParentRoute: () => rootRouteImport
          })
const LiveOakRoute = LiveOakRouteImport.update({
            id: '/live-oak',path: '/live-oak',getParentRoute: () => rootRouteImport
          })
const LocalFaqsRoute = LocalFaqsRouteImport.update({
            id: '/local-faqs',path: '/local-faqs',getParentRoute: () => rootRouteImport
          })
const LockhartRoute = LockhartRouteImport.update({
            id: '/lockhart',path: '/lockhart',getParentRoute: () => rootRouteImport
          })
const LoneStarEliteRoute = LoneStarEliteRouteImport.update({
            id: '/lone-star-elite',path: '/lone-star-elite',getParentRoute: () => rootRouteImport
          })
const LonghornSeriesRoute = LonghornSeriesRouteImport.update({
            id: '/longhorn-series',path: '/longhorn-series',getParentRoute: () => rootRouteImport
          })
const LouveredPergolasRoute = LouveredPergolasRouteImport.update({
            id: '/louvered-pergolas',path: '/louvered-pergolas',getParentRoute: () => rootRouteImport
          })
const LulingRoute = LulingRouteImport.update({
            id: '/luling',path: '/luling',getParentRoute: () => rootRouteImport
          })
const McallenRoute = McallenRouteImport.update({
            id: '/mcallen',path: '/mcallen',getParentRoute: () => rootRouteImport
          })
const MetalAwningsRoute = MetalAwningsRouteImport.update({
            id: '/metal-awnings',path: '/metal-awnings',getParentRoute: () => rootRouteImport
          })
const NewBraunfelsRoute = NewBraunfelsRouteImport.update({
            id: '/new-braunfels',path: '/new-braunfels',getParentRoute: () => rootRouteImport
          })
const OutdoorCoolingMistingRoute = OutdoorCoolingMistingRouteImport.update({
            id: '/outdoor-cooling-misting',path: '/outdoor-cooling-misting',getParentRoute: () => rootRouteImport
          })
const OutdoorHvacRoute = OutdoorHvacRouteImport.update({
            id: '/outdoor-hvac',path: '/outdoor-hvac',getParentRoute: () => rootRouteImport
          })
const OutdoorLightingRoute = OutdoorLightingRouteImport.update({
            id: '/outdoor-lighting',path: '/outdoor-lighting',getParentRoute: () => rootRouteImport
          })
const OutdoorRecreationSeriesRoute = OutdoorRecreationSeriesRouteImport.update({
            id: '/outdoor-recreation-series',path: '/outdoor-recreation-series',getParentRoute: () => rootRouteImport
          })
const PatioCanopyRoute = PatioCanopyRouteImport.update({
            id: '/patio-canopy',path: '/patio-canopy',getParentRoute: () => rootRouteImport
          })
const PatioCoversRoute = PatioCoversRouteImport.update({
            id: '/patio-covers',path: '/patio-covers',getParentRoute: () => rootRouteImport
          })
const PearlandRoute = PearlandRouteImport.update({
            id: '/pearland',path: '/pearland',getParentRoute: () => rootRouteImport
          })
const PergolaCoversRoute = PergolaCoversRouteImport.update({
            id: '/pergola-covers',path: '/pergola-covers',getParentRoute: () => rootRouteImport
          })
const PflugervilleRoute = PflugervilleRouteImport.update({
            id: '/pflugerville',path: '/pflugerville',getParentRoute: () => rootRouteImport
          })
const PlaygroundShadeRoute = PlaygroundShadeRouteImport.update({
            id: '/playground-shade',path: '/playground-shade',getParentRoute: () => rootRouteImport
          })
const PleasantonRoute = PleasantonRouteImport.update({
            id: '/pleasanton',path: '/pleasanton',getParentRoute: () => rootRouteImport
          })
const PoolSpaRoute = PoolSpaRouteImport.update({
            id: '/pool-spa',path: '/pool-spa',getParentRoute: () => rootRouteImport
          })
const PortAransasRoute = PortAransasRouteImport.update({
            id: '/port-aransas',path: '/port-aransas',getParentRoute: () => rootRouteImport
          })
const PortOconnorRoute = PortOconnorRouteImport.update({
            id: '/port-oconnor',path: '/port-oconnor',getParentRoute: () => rootRouteImport
          })
const PortlandRoute = PortlandRouteImport.update({
            id: '/portland',path: '/portland',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProductsRoute = ProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const RangerCareRoute = RangerCareRouteImport.update({
            id: '/ranger-care',path: '/ranger-care',getParentRoute: () => rootRouteImport
          })
const RangerSeriesRoute = RangerSeriesRouteImport.update({
            id: '/ranger-series',path: '/ranger-series',getParentRoute: () => rootRouteImport
          })
const RecoverAwningsRoute = RecoverAwningsRouteImport.update({
            id: '/recover-awnings',path: '/recover-awnings',getParentRoute: () => rootRouteImport
          })
const RepublicSeriesRoute = RepublicSeriesRouteImport.update({
            id: '/republic-series',path: '/republic-series',getParentRoute: () => rootRouteImport
          })
const RequestAQuoteRoute = RequestAQuoteRouteImport.update({
            id: '/request-a-quote',path: '/request-a-quote',getParentRoute: () => rootRouteImport
          })
const ResidentialAwningsRoute = ResidentialAwningsRouteImport.update({
            id: '/residential-awnings',path: '/residential-awnings',getParentRoute: () => rootRouteImport
          })
const RestaurantAwningsRoute = RestaurantAwningsRouteImport.update({
            id: '/restaurant-awnings',path: '/restaurant-awnings',getParentRoute: () => rootRouteImport
          })
const RetractableAwningsRoute = RetractableAwningsRouteImport.update({
            id: '/retractable-awnings',path: '/retractable-awnings',getParentRoute: () => rootRouteImport
          })
const RevivalSeriesRoute = RevivalSeriesRouteImport.update({
            id: '/revival-series',path: '/revival-series',getParentRoute: () => rootRouteImport
          })
const RioGrandeSeriesRoute = RioGrandeSeriesRouteImport.update({
            id: '/rio-grande-series',path: '/rio-grande-series',getParentRoute: () => rootRouteImport
          })
const RockportRoute = RockportRouteImport.update({
            id: '/rockport',path: '/rockport',getParentRoute: () => rootRouteImport
          })
const RoundRockRoute = RoundRockRouteImport.update({
            id: '/round-rock',path: '/round-rock',getParentRoute: () => rootRouteImport
          })
const RvCoversRoute = RvCoversRouteImport.update({
            id: '/rv-covers',path: '/rv-covers',getParentRoute: () => rootRouteImport
          })
const SafariGlampingTentsRoute = SafariGlampingTentsRouteImport.update({
            id: '/safari-glamping-tents',path: '/safari-glamping-tents',getParentRoute: () => rootRouteImport
          })
const SailShadesRoute = SailShadesRouteImport.update({
            id: '/sail-shades',path: '/sail-shades',getParentRoute: () => rootRouteImport
          })
const SanAntonioRoute = SanAntonioRouteImport.update({
            id: '/san-antonio',path: '/san-antonio',getParentRoute: () => rootRouteImport
          })
const SanMarcosRoute = SanMarcosRouteImport.update({
            id: '/san-marcos',path: '/san-marcos',getParentRoute: () => rootRouteImport
          })
const SchertzRoute = SchertzRouteImport.update({
            id: '/schertz',path: '/schertz',getParentRoute: () => rootRouteImport
          })
const SchoolShadeStructuresRoute = SchoolShadeStructuresRouteImport.update({
            id: '/school-shade-structures',path: '/school-shade-structures',getParentRoute: () => rootRouteImport
          })
const SchoolsAthleticsRoute = SchoolsAthleticsRouteImport.update({
            id: '/schools-athletics',path: '/schools-athletics',getParentRoute: () => rootRouteImport
          })
const SeguinRoute = SeguinRouteImport.update({
            id: '/seguin',path: '/seguin',getParentRoute: () => rootRouteImport
          })
const SeriesRoute = SeriesRouteImport.update({
            id: '/series',path: '/series',getParentRoute: () => rootRouteImport
          })
const ServiceAreasRoute = ServiceAreasRouteImport.update({
            id: '/service-areas',path: '/service-areas',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const SolairVsRoute = SolairVsRouteImport.update({
            id: '/solair-vs',path: '/solair-vs',getParentRoute: () => rootRouteImport
          })
const SouthPadreIslandRoute = SouthPadreIslandRouteImport.update({
            id: '/south-padre-island',path: '/south-padre-island',getParentRoute: () => rootRouteImport
          })
const SpringBranchRoute = SpringBranchRouteImport.update({
            id: '/spring-branch',path: '/spring-branch',getParentRoute: () => rootRouteImport
          })
const StockTrailerCoversRoute = StockTrailerCoversRouteImport.update({
            id: '/stock-trailer-covers',path: '/stock-trailer-covers',getParentRoute: () => rootRouteImport
          })
const SugarLandRoute = SugarLandRouteImport.update({
            id: '/sugar-land',path: '/sugar-land',getParentRoute: () => rootRouteImport
          })
const TheWoodlandsRoute = TheWoodlandsRouteImport.update({
            id: '/the-woodlands',path: '/the-woodlands',getParentRoute: () => rootRouteImport
          })
const TrailerCoversRoute = TrailerCoversRouteImport.update({
            id: '/trailer-covers',path: '/trailer-covers',getParentRoute: () => rootRouteImport
          })
const TrailerWiringRoute = TrailerWiringRouteImport.update({
            id: '/trailer-wiring',path: '/trailer-wiring',getParentRoute: () => rootRouteImport
          })
const UniversalCityRoute = UniversalCityRouteImport.update({
            id: '/universal-city',path: '/universal-city',getParentRoute: () => rootRouteImport
          })
const UtvAtvCoversRoute = UtvAtvCoversRouteImport.update({
            id: '/utv-atv-covers',path: '/utv-atv-covers',getParentRoute: () => rootRouteImport
          })
const UvaldeRoute = UvaldeRouteImport.update({
            id: '/uvalde',path: '/uvalde',getParentRoute: () => rootRouteImport
          })
const VerticalShadesLpRoute = VerticalShadesLpRouteImport.update({
            id: '/vertical-shades-lp',path: '/vertical-shades-lp',getParentRoute: () => rootRouteImport
          })
const VictoriaRoute = VictoriaRouteImport.update({
            id: '/victoria',path: '/victoria',getParentRoute: () => rootRouteImport
          })
const ViewOurWorkRoute = ViewOurWorkRouteImport.update({
            id: '/view-our-work',path: '/view-our-work',getParentRoute: () => rootRouteImport
          })
const WagonCoversRoute = WagonCoversRouteImport.update({
            id: '/wagon-covers',path: '/wagon-covers',getParentRoute: () => rootRouteImport
          })
const WhyTexasMadeShadeRoute = WhyTexasMadeShadeRouteImport.update({
            id: '/why-texas-made-shade',path: '/why-texas-made-shade',getParentRoute: () => rootRouteImport
          })
const WimberleyRoute = WimberleyRouteImport.update({
            id: '/wimberley',path: '/wimberley',getParentRoute: () => rootRouteImport
          })
const AdminAlertsRoute = AdminAlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRoute
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AdminRoute
          })
const AdminSearchesRoute = AdminSearchesRouteImport.update({
            id: '/searches',path: '/searches',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CaseStudiesRoute
          })
const SeriesSlugRoute = SeriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => SeriesRoute
          })
const ShopOrderCompleteRoute = ShopOrderCompleteRouteImport.update({
            id: '/order-complete',path: '/order-complete',getParentRoute: () => ShopRoute
          })
const VideosDropCurtainsRoute = VideosDropCurtainsRouteImport.update({
            id: '/videos/drop-curtains',path: '/videos/drop-curtains',getParentRoute: () => rootRouteImport
          })
const VideosSunbrellaFabricRoute = VideosSunbrellaFabricRouteImport.update({
            id: '/videos/sunbrella-fabric',path: '/videos/sunbrella-fabric',getParentRoute: () => rootRouteImport
          })
const AluminumPatioCoversInAustinRoute = AluminumPatioCoversInAustinRouteImport.update({
            id: '/aluminum-patio-covers/in/austin',path: '/aluminum-patio-covers/in/austin',getParentRoute: () => rootRouteImport
          })
const AluminumPatioCoversInSanAntonioRoute = AluminumPatioCoversInSanAntonioRouteImport.update({
            id: '/aluminum-patio-covers/in/san-antonio',path: '/aluminum-patio-covers/in/san-antonio',getParentRoute: () => rootRouteImport
          })
const AwningsInCityRoute = AwningsInCityRouteImport.update({
            id: '/in/$city',path: '/in/$city',getParentRoute: () => AwningsRoute
          })
const BlogTopicTagRoute = BlogTopicTagRouteImport.update({
            id: '/blog/topic/$tag',path: '/blog/topic/$tag',getParentRoute: () => rootRouteImport
          })
const BoatCoversInCityRoute = BoatCoversInCityRouteImport.update({
            id: '/in/$city',path: '/in/$city',getParentRoute: () => BoatCoversRoute
          })
const CaseStudiesInCityRoute = CaseStudiesInCityRouteImport.update({
            id: '/in/$city',path: '/in/$city',getParentRoute: () => CaseStudiesRoute
          })
const InsulatedPatioCoversInAustinRoute = InsulatedPatioCoversInAustinRouteImport.update({
            id: '/insulated-patio-covers/in/austin',path: '/insulated-patio-covers/in/austin',getParentRoute: () => rootRouteImport
          })
const InsulatedPatioCoversInSanAntonioRoute = InsulatedPatioCoversInSanAntonioRouteImport.update({
            id: '/insulated-patio-covers/in/san-antonio',path: '/insulated-patio-covers/in/san-antonio',getParentRoute: () => rootRouteImport
          })
const LouveredPatioCoversInAustinRoute = LouveredPatioCoversInAustinRouteImport.update({
            id: '/louvered-patio-covers/in/austin',path: '/louvered-patio-covers/in/austin',getParentRoute: () => rootRouteImport
          })
const LouveredPatioCoversInSanAntonioRoute = LouveredPatioCoversInSanAntonioRouteImport.update({
            id: '/louvered-patio-covers/in/san-antonio',path: '/louvered-patio-covers/in/san-antonio',getParentRoute: () => rootRouteImport
          })
const MotorizedDropScreensInCityRoute = MotorizedDropScreensInCityRouteImport.update({
            id: '/motorized-drop-screens/in/$city',path: '/motorized-drop-screens/in/$city',getParentRoute: () => rootRouteImport
          })
const PatioCoversInAustinRoute = PatioCoversInAustinRouteImport.update({
            id: '/in/austin',path: '/in/austin',getParentRoute: () => PatioCoversRoute
          })
const PatioCoversInSanAntonioRoute = PatioCoversInSanAntonioRouteImport.update({
            id: '/in/san-antonio',path: '/in/san-antonio',getParentRoute: () => PatioCoversRoute
          })
const PatioEnclosuresInAustinRoute = PatioEnclosuresInAustinRouteImport.update({
            id: '/patio-enclosures/in/austin',path: '/patio-enclosures/in/austin',getParentRoute: () => rootRouteImport
          })
const PatioEnclosuresInSanAntonioRoute = PatioEnclosuresInSanAntonioRouteImport.update({
            id: '/patio-enclosures/in/san-antonio',path: '/patio-enclosures/in/san-antonio',getParentRoute: () => rootRouteImport
          })
const PergolaCoversInCityRoute = PergolaCoversInCityRouteImport.update({
            id: '/in/$city',path: '/in/$city',getParentRoute: () => PergolaCoversRoute
          })
const RecoverAwningsInCityRoute = RecoverAwningsInCityRouteImport.update({
            id: '/in/$city',path: '/in/$city',getParentRoute: () => RecoverAwningsRoute
          })
const ShopBoatingSlugRoute = ShopBoatingSlugRouteImport.update({
            id: '/boating/$slug',path: '/boating/$slug',getParentRoute: () => ShopRoute
          })
const ShopCleanersSlugRoute = ShopCleanersSlugRouteImport.update({
            id: '/cleaners/$slug',path: '/cleaners/$slug',getParentRoute: () => ShopRoute
          })
const ShopGluesSlugRoute = ShopGluesSlugRouteImport.update({
            id: '/glues/$slug',path: '/glues/$slug',getParentRoute: () => ShopRoute
          })
const ShopHardwareSlugRoute = ShopHardwareSlugRouteImport.update({
            id: '/hardware/$slug',path: '/hardware/$slug',getParentRoute: () => ShopRoute
          })
const ShopThreadsSlugRoute = ShopThreadsSlugRouteImport.update({
            id: '/threads/$slug',path: '/threads/$slug',getParentRoute: () => ShopRoute
          })





const AdminRouteChildren = {
  AdminAlertsRoute: AdminAlertsRoute,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminBlogRoute: AdminBlogRoute,AdminSearchesRoute: AdminSearchesRoute,AdminSettingsRoute: AdminSettingsRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AwningsRouteChildren = {
  AwningsInCityRoute: AwningsInCityRoute
}

const AwningsRouteWithChildren = AwningsRoute._addFileChildren(AwningsRouteChildren)




const BoatCoversRouteChildren = {
  BoatCoversInCityRoute: BoatCoversInCityRoute
}

const BoatCoversRouteWithChildren = BoatCoversRoute._addFileChildren(BoatCoversRouteChildren)




const CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,CaseStudiesInCityRoute: CaseStudiesInCityRoute
}

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(CaseStudiesRouteChildren)




const PatioCoversRouteChildren = {
  PatioCoversInAustinRoute: PatioCoversInAustinRoute,PatioCoversInSanAntonioRoute: PatioCoversInSanAntonioRoute
}

const PatioCoversRouteWithChildren = PatioCoversRoute._addFileChildren(PatioCoversRouteChildren)




const PergolaCoversRouteChildren = {
  PergolaCoversInCityRoute: PergolaCoversInCityRoute
}

const PergolaCoversRouteWithChildren = PergolaCoversRoute._addFileChildren(PergolaCoversRouteChildren)




const RecoverAwningsRouteChildren = {
  RecoverAwningsInCityRoute: RecoverAwningsInCityRoute
}

const RecoverAwningsRouteWithChildren = RecoverAwningsRoute._addFileChildren(RecoverAwningsRouteChildren)




const SeriesRouteChildren = {
  SeriesSlugRoute: SeriesSlugRoute
}

const SeriesRouteWithChildren = SeriesRoute._addFileChildren(SeriesRouteChildren)




const ShopRouteChildren = {
  ShopOrderCompleteRoute: ShopOrderCompleteRoute,ShopBoatingSlugRoute: ShopBoatingSlugRoute,ShopCleanersSlugRoute: ShopCleanersSlugRoute,ShopGluesSlugRoute: ShopGluesSlugRoute,ShopHardwareSlugRoute: ShopHardwareSlugRoute,ShopThreadsSlugRoute: ShopThreadsSlugRoute
}

const ShopRouteWithChildren = ShopRoute._addFileChildren(ShopRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AccessibilityRoute: AccessibilityRoute,AdminRoute: AdminRouteWithChildren,AlamoSeriesRoute: AlamoSeriesRoute,AransasPassRoute: AransasPassRoute,ArchitectsRoute: ArchitectsRoute,AustinRoute: AustinRoute,AuthRoute: AuthRoute,AwningsRoute: AwningsRouteWithChildren,BacklitAwningsRoute: BacklitAwningsRoute,BanderaRoute: BanderaRoute,BastropRoute: BastropRoute,BeevilleRoute: BeevilleRoute,BluebonnetSeriesRoute: BluebonnetSeriesRoute,BoatCoversRoute: BoatCoversRouteWithChildren,BoerneRoute: BoerneRoute,BrownsvilleRoute: BrownsvilleRoute,BudaRoute: BudaRoute,BuiltInTexasRoute: BuiltInTexasRoute,BulverdeRoute: BulverdeRoute,CanyonLakeRoute: CanyonLakeRoute,CarWashShadeSailsRoute: CarWashShadeSailsRoute,CaseStudiesRoute: CaseStudiesRouteWithChildren,CastrovilleRoute: CastrovilleRoute,CedarParkRoute: CedarParkRoute,CentralTexasRoute: CentralTexasRoute,ChurchShadeStructuresRoute: ChurchShadeStructuresRoute,CiboloRoute: CiboloRoute,ComfortRoute: ComfortRoute,CommercialAwningsRoute: CommercialAwningsRoute,CommercialEventTentsRoute: CommercialEventTentsRoute,ConroeRoute: ConroeRoute,ContactRoute: ContactRoute,ConverseRoute: ConverseRoute,CoolerGunGearCoversRoute: CoolerGunGearCoversRoute,CorpusChristiRoute: CorpusChristiRoute,CoveredParkingRoute: CoveredParkingRoute,CoversChar38TopsRoute: CoversChar38TopsRoute,CoversTopsRoute: CoversTopsRoute,CueroRoute: CueroRoute,CurtainsRoute: CurtainsRoute,CustomAwningsRoute: CustomAwningsRoute,CustomFabricationRoute: CustomFabricationRoute,DeerBlindCoversRoute: DeerBlindCoversRoute,DeerBlindsAndHuntingRoute: DeerBlindsAndHuntingRoute,DelRioRoute: DelRioRoute,DogBoxesRoute: DogBoxesRoute,DrippingSpringsRoute: DrippingSpringsRoute,EaglePassRoute: EaglePassRoute,EdinburgRoute: EdinburgRoute,EstimateQuotesRoute: EstimateQuotesRoute,ExteriorVerticalShadesRoute: ExteriorVerticalShadesRoute,FabricAwningsRoute: FabricAwningsRoute,FabricsRoute: FabricsRoute,FaqsRoute: FaqsRoute,FarmingRanchingSeriesRoute: FarmingRanchingSeriesRoute,FindYourShadeRoute: FindYourShadeRoute,FloresvilleRoute: FloresvilleRoute,FredericksburgRoute: FredericksburgRoute,GalvestonRoute: GalvestonRoute,GazeboPrivacyPanelsRoute: GazeboPrivacyPanelsRoute,GeorgetownRoute: GeorgetownRoute,GonzalesRoute: GonzalesRoute,GulfCoastRoute: GulfCoastRoute,HarlingenRoute: HarlingenRoute,HelotesRoute: HelotesRoute,HillCountryRoute: HillCountryRoute,HillCountrySeriesRoute: HillCountrySeriesRoute,HogTrapsAndCagesRoute: HogTrapsAndCagesRoute,HondoRoute: HondoRoute,HoustonRoute: HoustonRoute,HuntingFishingCoversRoute: HuntingFishingCoversRoute,KatyRoute: KatyRoute,KerrvilleRoute: KerrvilleRoute,KingsvilleRoute: KingsvilleRoute,KyleRoute: KyleRoute,LaredoRoute: LaredoRoute,LeagueCityRoute: LeagueCityRoute,LiveOakRoute: LiveOakRoute,LocalFaqsRoute: LocalFaqsRoute,LockhartRoute: LockhartRoute,LoneStarEliteRoute: LoneStarEliteRoute,LonghornSeriesRoute: LonghornSeriesRoute,LouveredPergolasRoute: LouveredPergolasRoute,LulingRoute: LulingRoute,McallenRoute: McallenRoute,MetalAwningsRoute: MetalAwningsRoute,NewBraunfelsRoute: NewBraunfelsRoute,OutdoorCoolingMistingRoute: OutdoorCoolingMistingRoute,OutdoorHvacRoute: OutdoorHvacRoute,OutdoorLightingRoute: OutdoorLightingRoute,OutdoorRecreationSeriesRoute: OutdoorRecreationSeriesRoute,PatioCanopyRoute: PatioCanopyRoute,PatioCoversRoute: PatioCoversRouteWithChildren,PearlandRoute: PearlandRoute,PergolaCoversRoute: PergolaCoversRouteWithChildren,PflugervilleRoute: PflugervilleRoute,PlaygroundShadeRoute: PlaygroundShadeRoute,PleasantonRoute: PleasantonRoute,PoolSpaRoute: PoolSpaRoute,PortAransasRoute: PortAransasRoute,PortOconnorRoute: PortOconnorRoute,PortlandRoute: PortlandRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ProductsRoute: ProductsRoute,ProjectsRoute: ProjectsRoute,RangerCareRoute: RangerCareRoute,RangerSeriesRoute: RangerSeriesRoute,RecoverAwningsRoute: RecoverAwningsRouteWithChildren,RepublicSeriesRoute: RepublicSeriesRoute,RequestAQuoteRoute: RequestAQuoteRoute,ResidentialAwningsRoute: ResidentialAwningsRoute,RestaurantAwningsRoute: RestaurantAwningsRoute,RetractableAwningsRoute: RetractableAwningsRoute,RevivalSeriesRoute: RevivalSeriesRoute,RioGrandeSeriesRoute: RioGrandeSeriesRoute,RockportRoute: RockportRoute,RoundRockRoute: RoundRockRoute,RvCoversRoute: RvCoversRoute,SafariGlampingTentsRoute: SafariGlampingTentsRoute,SailShadesRoute: SailShadesRoute,SanAntonioRoute: SanAntonioRoute,SanMarcosRoute: SanMarcosRoute,SchertzRoute: SchertzRoute,SchoolShadeStructuresRoute: SchoolShadeStructuresRoute,SchoolsAthleticsRoute: SchoolsAthleticsRoute,SeguinRoute: SeguinRoute,SeriesRoute: SeriesRouteWithChildren,ServiceAreasRoute: ServiceAreasRoute,ShopRoute: ShopRouteWithChildren,SolairVsRoute: SolairVsRoute,SouthPadreIslandRoute: SouthPadreIslandRoute,SpringBranchRoute: SpringBranchRoute,StockTrailerCoversRoute: StockTrailerCoversRoute,SugarLandRoute: SugarLandRoute,TheWoodlandsRoute: TheWoodlandsRoute,TrailerCoversRoute: TrailerCoversRoute,TrailerWiringRoute: TrailerWiringRoute,UniversalCityRoute: UniversalCityRoute,UtvAtvCoversRoute: UtvAtvCoversRoute,UvaldeRoute: UvaldeRoute,VerticalShadesLpRoute: VerticalShadesLpRoute,VictoriaRoute: VictoriaRoute,ViewOurWorkRoute: ViewOurWorkRoute,WagonCoversRoute: WagonCoversRoute,WhyTexasMadeShadeRoute: WhyTexasMadeShadeRoute,WimberleyRoute: WimberleyRoute,BlogSlugRoute: BlogSlugRoute,VideosDropCurtainsRoute: VideosDropCurtainsRoute,VideosSunbrellaFabricRoute: VideosSunbrellaFabricRoute,BlogIndexRoute: BlogIndexRoute,AluminumPatioCoversInAustinRoute: AluminumPatioCoversInAustinRoute,AluminumPatioCoversInSanAntonioRoute: AluminumPatioCoversInSanAntonioRoute,BlogTopicTagRoute: BlogTopicTagRoute,InsulatedPatioCoversInAustinRoute: InsulatedPatioCoversInAustinRoute,InsulatedPatioCoversInSanAntonioRoute: InsulatedPatioCoversInSanAntonioRoute,LouveredPatioCoversInAustinRoute: LouveredPatioCoversInAustinRoute,LouveredPatioCoversInSanAntonioRoute: LouveredPatioCoversInSanAntonioRoute,MotorizedDropScreensInCityRoute: MotorizedDropScreensInCityRoute,PatioEnclosuresInAustinRoute: PatioEnclosuresInAustinRoute,PatioEnclosuresInSanAntonioRoute: PatioEnclosuresInSanAntonioRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)